<template>
  <input type="file" @change="onImageChange"/>

  <div class="mt-3" v-if="hasImage()">
    Блок для вставки:
    <pre ref="imageHtmlRef">{{ getImageHtml() }}</pre>
    <button @click="copyHtml" class="btn btn-sm btn-primary mt-1">
      Скопировать
    </button>
  </div>

  <template v-if="isLoadImage()">
    <div class="mt-3">
      <div class="progress progress-sm">
        <div class="progress-bar progress-bar-indeterminate"></div>
      </div>
    </div>
  </template>
</template>

<script setup>
import {ref} from "vue"
import Api from "./services/Api"
import Image from "@/services/Image"
import Notify from "@/services/Notify";

let loadImage = ref(false)
let image = ref({
  "host": "",
  "name": "",
})

const imageHtmlRef = ref(null)

function getPayload(obj) {
  const formData = new FormData()

  Object.entries(obj).forEach(([key, val]) => {
    formData.append(key, val)
  })

  return formData
}

function isLoadImage() {
  return loadImage.value === true
}

function onImageChange(e) {
  loadImage.value = true

  Api.uploadImage(getPayload({
    image: e.target.files[0],
  })).then((resp) => {
    let imageResp = resp?.data?.image

    if (!imageResp?.host || !imageResp?.name) {
      return
    }

    image.value = {
      host: imageResp?.host,
      name: imageResp?.name,
    }
  }).finally(() => {
    loadImage.value = false
    e.target.value = ''
  })
}

function hasImage() {
  return image.value.host && image.value.name
}

function getPathImage() {
  return Image.handle(image.value.host, image.value.name, null, null)
}

function getImageHtml() {
  const src = getPathImage()
  return `<figure><img src="${src}" alt=""></figure>`
}

function copyHtml() {
  if (!imageHtmlRef.value) {
    return
  }

  navigator.clipboard.writeText(getImageHtml())
      .then(() => {
        Notify.success("Скопировано")
      })
      .catch(() => {
        Notify.error("Не удалось скопировать")
      })
}
</script>

<style scoped></style>
